// Çalışma > Craft menüsündeki kilit. Sunucudaki asıl değer
// backend/data/craft_recipes.json > settings.unlockLevel; ikisi aynı tutulmalı.
export const CRAFT_MIN_LEVEL = 1;
